// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import gsap from "gsap";
// import logo from "../../Assets/WhiteLogo.png";
// import logo1 from "../../Assets/logo.png";

// const Appbar = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [showScrollAppBar, setShowScrollAppBar] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const navLinks = [
//     { name: "HOME", path: "/" },
//     { name: "ABOUT", path: "/about" },
//     { name: "SERVICES", path: "/services" },
//     { name: "CONTACT", path: "/contact" },
//     { name: "PORTFOLIO", path: "/portfolio" },
//   ];

//   useEffect(() => {
//     const checkMobileScreen = () => {
//       if (window.innerWidth <= 768) {
//         setIsMobile(true);
//       } else {
//         setIsMobile(false);
//       }
//     };

//     checkMobileScreen();
//     window.addEventListener("resize", checkMobileScreen);

//     return () => window.removeEventListener("resize", checkMobileScreen);
//   }, []);

//   useEffect(() => {
//     const initializeGSAP = () => {
//       if (!isMobile) {
//         gsap.set(".secondary-app-bar", { y: "-100%" });
//       }
//     };

//     initializeGSAP();

//     const handleScroll = () => {
//       if (!isMobile && window.scrollY > 100) {
//         setShowScrollAppBar(true);
//         gsap.to(".secondary-app-bar", {
//           y: 0,
//           duration: 0.8,
//           ease: "power4.out",
//         });
//       } else {
//         setShowScrollAppBar(false);
//         gsap.to(".secondary-app-bar", {
//           y: "-100%",
//           duration: 0.8,
//           ease: "power4.in",
//         });
//       }
//     };

//     window.addEventListener("scroll", handleScroll);
//     window.addEventListener("resize", initializeGSAP);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//       window.removeEventListener("resize", initializeGSAP);
//     };
//   }, [isMobile]);

//   const CrossIcon = () => (
//     <svg
//       viewBox="0 0 24 24"
//       className="w-8 h-8"
//       stroke="currentColor"
//       fill="none"
//       strokeWidth="1.5"
//     >
//       <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" />
//     </svg>
//   );

//   const MenuIcon = () => (
//     <svg
//       viewBox="0 0 24 24"
//       className="w-6 h-6"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <path d="M4 6h16M4 12h16M4 18h16" />
//     </svg>
//   );

//   return (
//     <nav className="relative z-50">
//       <div
//         className={`hidden lg:flex items-center justify-between py-3 px-6 bg-transparent`}
//       >
//         <div className="w-24"></div>
//         <div className="flex items-center space-x-32 xl:space-x-64">
//           {/* Left Navigation Tabs */}
//           <div className="flex items-center space-x-14 xl:space-x-20">
//             {navLinks.slice(0, 2).map((link) => (
//               <button
//                 key={link.name}
//                 onClick={() => navigate(link.path)}
//                 className={`${
//                   // location.pathname === "/about" ||
//                   location.pathname === "/contact"
//                     ? //  ||
//                       // location.pathname === "/portfolio"
//                       "text-[#704735] hover:text-[#5a3b2d]"
//                     : "text-white hover:text-gray-200"
//                 } text-lg font-semibold`}
//               >
//                 {link.name}
//               </button>
//             ))}
//           </div>

//           {/* Logo Section */}
//           <button onClick={() => navigate("/")} className="flex items-center">
//             <img
//               src={
//                 // location.pathname === "/about" ||
//                 location.pathname === "/contact"
//                   ? // ||
//                     // location.pathname === "/portfolio"
//                     logo1
//                   : logo
//               }
//               alt="Logo"
//               className="h-16 w-auto"
//             />
//           </button>

//           {/* Right Navigation Tabs */}
//           <div className="flex items-center space-x-12 xl:space-x-20">
//             {navLinks.slice(2).map((link) => (
//               <button
//                 key={link.name}
//                 onClick={() => navigate(link.path)}
//                 className={`${
//                   // location.pathname === "/about" ||
//                   location.pathname === "/contact"
//                     ? // ||
//                       // location.pathname === "/portfolio"
//                       "text-[#704735] hover:text-[#5a3b2d]"
//                     : "text-white hover:text-gray-200"
//                 } text-lg font-semibold`}
//               >
//                 {link.name}
//               </button>
//             ))}
//           </div>
//         </div>
//         <div className="w-24"></div>
//       </div>

//       {/* Mobile Navigation */}
//       <div className="lg:hidden">
//         <div
//           className={`flex items-center justify-between py-4 px-6 ${
//             // location.pathname === "/about" ||
//             location.pathname === "/contact"
//               ? // ||
//                 // location.pathname === "/portfolio"
//                 "bg-[#704735]"
//               : "bg-transparent"
//           }`}
//         >
//           <button onClick={() => navigate("/")} className="flex items-center">
//             <img src={logo} alt="Logo" className="h-12 w-auto" />
//           </button>
//           <button
//             onClick={() => setIsOpen(!isOpen)}
//             className="text-white"
//             aria-label={isOpen ? "Close menu" : "Open menu"}
//           >
//             <MenuIcon />
//           </button>
//         </div>

//         {/* Mobile Menu */}
//         {isOpen && (
//           <div className="fixed inset-0 bg-[#704735] z-50">
//             <div className="container mx-auto px-6 pt-6">
//               <div className="flex justify-end mb-8">
//                 <button
//                   onClick={() => setIsOpen(false)}
//                   className="text-white p-2"
//                   aria-label="Close menu"
//                 >
//                   <CrossIcon />
//                 </button>
//               </div>
//               <div
//                 className="text-center flex justify-center items-center py-10"
//                 style={{
//                   fontFamily: "uberschrift-Regular",
//                 }}
//               >
//                 <h1 className="text-4xl font-light tracking-widest text-white">
//                   Connect Engage Grow
//                 </h1>
//               </div>

//               <div className="space-y-8">
//                 {navLinks.map((link) => (
//                   <button
//                     key={link.name}
//                     onClick={() => {
//                       navigate(link.path);
//                       setIsOpen(false);
//                     }}
//                     className="block text-xl tracking-wider w-full text-center text-white"
//                   >
//                     {link.name}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Secondary App Bar (Mobile Hidden) */}
//       <div
//         className={`secondary-app-bar ${
//           isMobile ? "hidden" : ""
//         } fixed top-0 left-0 w-full h-20 shadow-md z-50 transition-transform transform`}
//         style={{
//           background: "rgba(112, 71, 53, 0.85)",
//           backdropFilter: "blur(8px)",
//           WebkitBackdropFilter: "blur(8px)",
//         }}
//       >
//         <div className="flex items-center justify-between px-12 lg:px-20 py-3">
//           {/* Logo Section */}
//           <button
//             onClick={() => navigate("/")}
//             className="flex items-center space-x-3"
//           >
//             <img src={logo} alt="Logo" className="h-14 w-auto" />
//           </button>

//           <div className="flex items-center space-x-6">
//             {navLinks.map((link) => (
//               <button
//                 key={link.name}
//                 onClick={() => navigate(link.path)}
//                 className="text-white hover:text-gray-300 text-base font-medium px-3 py-2 rounded-md transition-colors duration-200"
//               >
//                 {link.name}
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Appbar;

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import gsap from "gsap";
import logo from "../../Assets/WhiteLogo.png";
import logo1 from "../../Assets/logo.png";

const Appbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showScrollAppBar, setShowScrollAppBar] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navLinks = [
    { name: "HOME", path: "/" },
    { name: "ABOUT", path: "/about" },
    { name: "SERVICES", path: "/services" },
    { name: "PORTFOLIO", path: "/portfolio" },
  ];

  useEffect(() => {
    const checkMobileScreen = () => {
      if (window.innerWidth <= 768) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    checkMobileScreen();
    window.addEventListener("resize", checkMobileScreen);

    return () => window.removeEventListener("resize", checkMobileScreen);
  }, []);

  useEffect(() => {
    const initializeGSAP = () => {
      if (!isMobile) {
        gsap.set(".secondary-app-bar", { y: "-100%" });
      }
    };

    initializeGSAP();

    const handleScroll = () => {
      if (!isMobile && window.scrollY > 100) {
        setShowScrollAppBar(true);
        gsap.to(".secondary-app-bar", {
          y: 0,
          duration: 0.8,
          ease: "power4.out",
        });
      } else {
        setShowScrollAppBar(false);
        gsap.to(".secondary-app-bar", {
          y: "-100%",
          duration: 0.8,
          ease: "power4.in",
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", initializeGSAP);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", initializeGSAP);
    };
  }, [isMobile]);

  const CrossIcon = () => (
    <svg
      viewBox="0 0 24 24"
      className="w-8 h-8"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
    >
      <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" />
    </svg>
  );

  const MenuIcon = () => (
    <svg
      viewBox="0 0 24 24"
      className="w-6 h-6"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  );

  const ContactButton = ({ className = "", scrolled }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const isActive = ["/contact", "/booking"].includes(location.pathname);

    return (
      <button
        onClick={() => navigate("/contact")}
        className={`${className} px-6 py-2 rounded-full border-2 transition-colors duration-200
        ${
          scrolled
            ? "border-white text-white hover:bg-white hover:text-[#704735]"
            : isActive
            ? "border-[#704735] text-[#704735] hover:bg-[#704735] hover:text-white"
            : "border-white text-white hover:bg-white hover:text-[#704735]"
        }`}
      >
        CONTACT
      </button>
    );
  };

  return (
    <nav className="relative z-50">
      {/* Desktop Navigation */}
      <div className="hidden lg:flex items-center justify-between py-3 px-6 bg-transparent">
        <div className="w-24"></div>
        <div className="flex items-center space-x-32 xl:space-x-64">
          {/* Left Navigation Tabs */}
          <div className="flex items-center space-x-14 xl:space-x-20">
            {navLinks.slice(0, 2).map((link) => (
              <button
                key={link.name}
                onClick={() => navigate(link.path)}
                className={`${
                  ["/contact", "/booking"].includes(location.pathname)
                    ? "text-[#704735] hover:text-[#5a3b2d]"
                    : "text-white hover:text-gray-200"
                } text-lg font-semibold`}
              >
                {link.name}
              </button>
            ))}
          </div>

          {/* Logo Section */}
          <button onClick={() => navigate("/")} className="flex items-center">
            <img
              src={
                ["/contact", "/booking"].includes(location.pathname)
                  ? logo1
                  : logo
              }
              alt="Logo"
              className="h-16 w-auto"
            />
          </button>

          {/* Right Navigation Tabs */}
          <div className="flex items-center space-x-12 xl:space-x-20">
            {navLinks.slice(2).map((link) => (
              <button
                key={link.name}
                onClick={() => navigate(link.path)}
                className={`${
                  ["/contact", "/booking"].includes(location.pathname)
                    ? "text-[#704735] hover:text-[#5a3b2d]"
                    : "text-white hover:text-gray-200"
                } text-lg font-semibold`}
              >
                {link.name}
              </button>
            ))}
          </div>
        </div>
        {/* Contact Button in right corner */}
        <div className="w-24 flex justify-end">
          <ContactButton />
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className="lg:hidden">
        <div
          className={`flex items-center justify-between py-4 px-6 ${
            ["/contact", "/booking"].includes(location.pathname)
              ? "bg-[#704735]"
              : "bg-transparent"
          }`}
        >
          <button onClick={() => navigate("/")} className="flex items-center">
            <img src={logo} alt="Logo" className="h-12 w-auto" />
          </button>
          <div className="flex items-center space-x-4">
            {/* Only show contact button if not on contact page */}
            {["/contact", "/booking"].includes(location.pathname) && (
              <ContactButton className="text-sm" />
            )}
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white"
              aria-label={isOpen ? "Close menu" : "Open menu"}
            >
              <MenuIcon />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="fixed inset-0 bg-[#704735] z-50">
            <div className="container mx-auto px-6 pt-6">
              <div className="flex justify-end mb-8">
                <button
                  onClick={() => setIsOpen(false)}
                  className="text-white p-2"
                  aria-label="Close menu"
                >
                  <CrossIcon />
                </button>
              </div>
              <div
                className="text-center flex justify-center items-center py-10"
                style={{
                  fontFamily: "uberschrift-Regular",
                }}
              >
                <h1 className="text-4xl font-light tracking-widest text-white">
                  Connect Engage Grow
                </h1>
              </div>

              <div className="space-y-8">
                {navLinks.map((link) => (
                  <button
                    key={link.name}
                    onClick={() => {
                      navigate(link.path);
                      setIsOpen(false);
                    }}
                    className="block text-xl tracking-wider w-full text-center text-white"
                  >
                    {link.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Secondary App Bar (Mobile Hidden) */}
      <div
        className={`secondary-app-bar ${
          isMobile ? "hidden" : ""
        } fixed top-0 left-0 w-full h-20 shadow-md z-50 transition-transform transform`}
        style={{
          background: "rgba(112, 71, 53, 0.85)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
        }}
      >
        <div className="flex items-center justify-between px-12 lg:px-20 py-3">
          {/* Logo Section */}
          <button
            onClick={() => navigate("/")}
            className="flex items-center space-x-3"
          >
            <img src={logo} alt="Logo" className="h-14 w-auto" />
          </button>

          <div className="flex items-center space-x-6">
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => navigate(link.path)}
                className="text-white hover:text-gray-300 text-base font-medium px-3 py-2 rounded-md transition-colors duration-200"
              >
                {link.name}
              </button>
            ))}
            <ContactButton scrolled={showScrollAppBar} className="ml-4" />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Appbar;
